<template>
	<div>
		<p class="mb-3">Please type your answer in the box below</p>
		<div>
			<textarea
				class="textarea"
				type="text"
				placeholder="Enter your answer..."
				v-model="selectedAnswers"
				rows="4"
			></textarea>
		</div>
	</div>
</template>

<script lang="ts">
import { QuestionItemMixin } from '@/utils/skill-assessment-mixins'
import { defineComponent } from 'vue'

export default defineComponent({
	mixins: [QuestionItemMixin]
})
</script>

<style scoped>

</style>
